function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  stroke: "currentColor",
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M9.854 8.463L24.5 14l15.65-5.869a1 1 0 0 1 .7 0l15 5.59a1 1 0 0 1 .65.936v39.94a1 1 0 0 1-1.353.936L40.5 50l-15.65 5.869a1 1 0 0 1-.7 0l-15-5.594a1 1 0 0 1-.65-.937V9.398a1 1 0 0 1 1.354-.935zM24.5 14v42m16-48v42",
  strokeWidth: 3
}), React.createElement("path", {
  d: "M24.5 23l8.5-3m-8.5 9l8.5-3m-8.5 9l8.5-3m-8.5 9l8.5-3m-8.5 9l8.5-3",
  strokeLinecap: "round",
  strokeWidth: 2
}));

const SvgComponent = props => React.createElement("svg", _extends({
  viewBox: "0 0 64 64"
}, props), _ref);

export default __webpack_public_path__ + "static/media/map-alt.02e3082c.svg";
export { SvgComponent as ReactComponent };